import React, { Component } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink, Media } from 'reactstrap';
import './App.css';

//import { Link } from 'react-router-dom';

//<Route path="/" component={App}>
//    </Route>
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  
  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  
  render() {
    return (
      <header>
            {this.props.user.authenticated
            ? (
              <div>
                <Navbar className="navbar-dark bg-dark" dark expand="md">
                  <NavbarBrand href="/">Eastereggs </NavbarBrand>
                  <NavbarToggler onClick={this.toggle} />
                  <Collapse isOpen={this.state.isOpen} navbar>
                    <Nav className="ml-auto" navbar>
                      <NavItem>
                        <NavLink href="/logout">Logout</NavLink>
                      </NavItem>
                    </Nav>
                  </Collapse>
                </Navbar>
              </div>
            ) : (
              <div>
                <Navbar className="navbar-dark bg-dark" dark expand="md">
                  <NavbarBrand href="/login">Eastereggs </NavbarBrand> <Media object data-src="/img/easter-egg-64.gif" />
                </Navbar>
              </div>
            )}
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js